import React from 'react';
import { setCurrentView } from 'core/utils';
import { BulkPrintViewStore } from 'modules/order/stores';
import { BulkPrintTemplate } from 'themes/modules/order/pages';

@setCurrentView((rootStore, componentProps) => new BulkPrintViewStore(rootStore, componentProps), 'bulkPrintViewStore')
class BulkPrint extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <BulkPrintTemplate {...this.props} />;
	}
}

export default BulkPrint;



// WEBPACK FOOTER //
// ./src/modules/order/pages/BulkPrint.jsx